import "./assets/main.less"
import "vue-advanced-cropper/dist/style.css"
import PrimeVue from "primevue/config"
import {themePreset} from "./theme"
import DialogService from "primevue/dialogservice"
import ToastService from "primevue/toastservice"
import Tooltip from "primevue/tooltip"
import {VueQueryPlugin, QueryClient} from "@tanstack/vue-query"
import {createPrevRoutePlugin} from "@/plugins/PrevRoutePlugin"

import {createApp} from "vue"
import {createPinia} from "pinia"
import {i18n} from "./i18n"

import App from "./App.vue"
import router from "./router"
import initSentry from "../sentry"
import * as Sentry from "@sentry/vue"
import dayjs from "dayjs"
import "dayjs/locale/uk"
import {createGtag} from "vue-gtag"
import EChartsPlugin from "./plugins/echarts"
dayjs.locale("uk")

const app = createApp(App)
const pinia = createPinia()

initSentry(app, router)
import.meta.env.VITE_SENTRY_ENABLED === "true" && pinia.use(Sentry.createSentryPiniaPlugin())

// set glob properties
app.config.globalProperties.env = {
  // telegramBotLink: import.meta.env.VITE_telegramBotLink,
}
// previous route plugin
app.use(createPrevRoutePlugin(router))

app.use(PrimeVue, {
  theme: {
    preset: themePreset,
    options: {
      darkModeSelector: false,
    },
  },
})
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(DialogService)
app.use(ToastService)
app.directive("tooltip", Tooltip)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 5,
      staleTime: 1000 * 60 * 5,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
app.use(VueQueryPlugin, {
  queryClient,
})
app.use(EChartsPlugin)

try {
  const gtag = createGtag({
    tagId: import.meta.env.VITE_GA_TAG,
  })
  app.use(gtag)
} catch (e) {
  console.log("GA not available", e)
}

app.config.errorHandler = (err, instance, info) => {
  console.log("Error: ", err, instance, info)
  // show error notification or modal
  const error =
    err instanceof Error
      ? err
      : new Error(typeof err === "object" ? JSON.stringify(err) : String(err))
  Sentry.captureException(error)
}

app.provide("dayjs", dayjs)
app.mount("#app")
